require('./angular-busy');
module.exports = 'cgBusy';